import { PreferredLocale } from "../../../utils/locales";

export enum AnswerSummaryState {
  Correct = 0,
  Incorrect = 1,
  Skipped = 2,
}

export enum AnswerSummaryType {
  Choice = 0,
  Gap = 1,
  UnorderedList = 4,
  OrderedList = 2,
}

export type PartInstanceSummaryResponse = ["compactPartInstSummaries_v1", UserPartInstanceSummary[]];

export type UserPartInstanceSummary = [string, PartInstanceSummary[]];

/*
  ResponseSummary represents the PartInstResponseSummary data type in the Haskell backend:
  lib/better-pure-logic/src/Erudify/Logic/Tutor/Annotation/PartInsts/Internal.hs
  and the response field in answer_summaries in the relations.part_instance_summaries table.

  Example:
  [
    {"state":"correct","time":1692729452490,"locale":"en","response":{"tag":"choice","itemIds":[0]},"courseRevId":95}
  ]

  AnswerSummaryType (the first element in the ResponseSummary array) is the instruction type (sometimes called tag)
  and can be choice, gap, etc. Depending on this type, the second element of the array changes:

  - Choice => choice id or question id (number)
  - Gap => answer map (object)
*/

export type ResponseSummary = [AnswerSummaryType, ResponseChoice | ResponseGap];
export type ResponseChoice = number[][];
type ResponseGap = Array<Array<Record<number, string>>>;

export type PartInstanceSummary = [number, AnswerSummaryState, number, PreferredLocale | null, ResponseSummary | null];
